export default __webpack_public_path__ + "static/media/logo_web_white.6ab842a5.png";